export function tenantBase(pathname) {
  return pathname.match(/^\/t\/[^/]+(?=\/|$)/)?.[0] || '';
}

export function tenantLoginUrl(pathname, search = '') {
  const base = tenantBase(pathname);
  if (!base) return '/login';
  const params = new URLSearchParams({ next: `${pathname}${search}` });
  if (new URLSearchParams(search).get('embedded') === '1') params.set('embedded', '1');
  return `${base}/login?${params}`;
}

export function tenantReturnPath(slug, search = '') {
  const base = `/t/${slug}`;
  const params = new URLSearchParams(search);
  const next = params.get('next');
  const fallback = `${base}/dashboard${params.get('embedded') === '1' ? '?embedded=1' : ''}`;
  if (!next?.startsWith('/') || next.startsWith('//') || /[\\\r\n]/.test(next)) return fallback;
  const url = new URL(next, 'https://cip.invalid');
  if (url.origin !== 'https://cip.invalid' || (url.pathname !== base && !url.pathname.startsWith(`${base}/`))
    || [base + '/login', base + '/join'].includes(url.pathname.replace(/\/$/, ''))) return fallback;
  return `${url.pathname}${url.search}${url.hash}`;
}
